module.exports = __webpack_public_path__ + "img/map.001ac8dc.svg";